export default function Projects({ t, onSelectProject }) {
  const projects = t.projects;

  return (
    <section id="projects" className="premium-section">
      <div className="section-container">
        <div className="section-header">
          <span className="section-tag">Portfolio</span>
          <h3 className="section-title">{t.projTitle}</h3>
        </div>
        <div className="premium-grid">
          {Array.isArray(projects) && projects.map((project, idx) => (
            <div key={project.id || `proj-${idx}`} className="premium-card project-card card-animated" onClick={() => onSelectProject(project)}>
              <div className="card-gradient-border"></div>
              <div className="card-icon">
                {project.icon ? (
                  <img src={project.icon} alt={project.title} />
                ) : (
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>
                )}
              </div>
              <h4 className="card-title">{project.title}</h4>
              <p className="card-desc">{project.description.substring(0, 120)}...</p>
              <div className="project-view-link">
                <span>View Details</span>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
